import { useAuth0 } from "@auth0/auth0-react";
import { Link } from "react-router-dom";

import { Box } from "@/Components/v2/atoms/Box";
import { LinkButton } from "@/Components/v2/atoms/Button/LinkButton";
import { YellowButton } from "@/Components/v2/atoms/Button/YellowButton";
import { Card } from "@/Components/v2/atoms/Card";
import { Typography } from "@/Components/v2/atoms/Typography";
import { queryClient } from "@/lib/react-query";

const LogoutButton = (props) => {
  const { logout } = useAuth0();

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    queryClient.removeQueries();
    logout({ returnTo: window.location.origin });
  };
  return (
    <Link to={"#"} onClick={handleLogout}>
      {props.children}
    </Link>
  );
};

const ErrorTemplate = (props) => {
  const {
    Content = "",
    Headline,
    Subhead,
    Body = "",
    ButtonLink,
    ButtonText,
    hideButton,
    showLogoutButton = false,
  } = props;

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Box
        sx={{
          padding: 0,
          height: "100%",
          width: "100%",
        }}
      >
        <Card
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            height: "100%",
            padding: 0,
            margin: 0,
            boxShadow: "none",
            backgroundColor: "transparent",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                width: "100%",
                marginLeft: "20px",
                maxWidth: "300px",
                paddingTop: "30px",
                paddingBottom: "20px",
              }}
            >
              <div>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 900,
                    fontSize: "27px",
                  }}
                >
                  {Headline}
                </Typography>
              </div>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "15px",
                  fontWeight: 600,
                  marginBottom: "20px",
                  marginTop: "10px",
                }}
              >
                {Subhead}
              </Typography>

              {Content && (
                <>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "10px",
                      marginTop: "10px",
                    }}
                  >
                    {Content.P1}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "10px",
                      margin: "5px",
                    }}
                  >
                    {Content.P2}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "10px",
                      margin: "5px",
                    }}
                  >
                    {Content.P3}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "10px",
                      marginTop: "10px",
                    }}
                  >
                    {Content.P4}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "10px",
                      marginBottom: "40px",
                    }}
                  >
                    {Content.P5}
                  </Typography>
                </>
              )}

              {Body && (
                <>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "10px",
                      marginTop: "10px",
                    }}
                  >
                    {Body}
                  </Typography>
                </>
              )}

              {!hideButton && (
                <Box sx={{ margin: "5px" }}>
                  <LinkButton
                    href={ButtonLink}
                    sx={{
                      background: "#FFD700", // yellow color
                      color: "#000000",
                      padding: "7px 20px",
                      fontWeight: "bold",
                      border: "none",
                      borderRadius: "5px",
                      marginTop: "10px",
                      cursor: "pointer",
                      textDecoration: "none",
                      "&:hover": {
                        backgroundColor: "#FFD700",
                        textDecoration: "none",
                      },
                    }}
                  >
                    {ButtonText}
                  </LinkButton>
                </Box>
              )}

              {showLogoutButton && (
                <LogoutButton>
                  <YellowButton
                    sx={{
                      textTransform: "none",
                      fontWeight: 800,
                      fontSize: "13px",
                      marginTop: "10px",
                    }}
                  >
                    Logout
                  </YellowButton>
                </LogoutButton>
              )}
            </Box>
          </Box>
        </Card>
      </Box>
    </Box>
  );
};

export default ErrorTemplate;
